<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import OrderHistoryMedicineComponent from '../../Common/OrderHistoryMedicineComponent.vue';
import config from "../../../config.js";
import { errorAlert } from "../../../plugins/alert";
import { deepCopy } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';
import Breakpoint from '../../../compositions/Breakpoint.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const searchWord = ref('');
const searchDateFrom = ref('');
const searchDateTo = ref('');
const stockType = ref(-1);
const deleteReason = ref(-1);
const medicineIds = reactive([]);
const medicineOptions = reactive([]);
const pharmacyWholeSalerId = ref(0);
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const onSearchDateFromChange = (value) => {
  searchDateFrom.value = value;
  listSearch();
}
const onSearchDateToChange = (value) => {
  searchDateTo.value = value;
  listSearch();
}
const onSearchDateChange = (value) => {
  searchDate.value = value;
  listSearch();
}
const onSelectStockTypeChange = (value,label) => {
  stockType.value = value;
  listSearch();
}
const onSelectDeleteReasonChange = (value,label) => {
  deleteReason.value = value;
  listSearch();
}
const clearDate = () => {
  searchDateFrom.value = '';
  searchDateTo.value = '';
  listSearch();
}

const fields = reactive([
  {field_name: '', field_key: 'data_date', width: '15%', align: 'text-center', sorted:true},
  {field_name: '採用品', field_key: 'product_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '取引先', field_key: 'target_name', width: '10%', align: 'text-left', sorted:true},
  {field_name: '分類', field_key: 'warning_mark', width: '5%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'stock_type', width: '5%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_content', width: '10%', align: 'text-center', sorted:false},
  {field_name: '数量', field_key: 'number', width: '10%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_history_content', width: '10%', align: 'text-center', sorted:false},
  {field_name: '単価', field_key: 'unit_price', width: '10%', align: 'text-center', sorted:true},
  {field_name: '金額', field_key: 'total_price', width: '10%', align: 'text-center', sorted:true},
]);
const optionFields = reactive({
  'search_word' : searchWord.value,
  'history_date_from' : searchDateFrom.value,
  'history_date_to' : searchDateTo.value,
  'pharmacy_wholesaler_id': (pharmacyWholeSalerId.value ? pharmacyWholeSalerId.value : null),
  'stock_type' : stockType.value,
  'stock_reason' : deleteReason.value,
  'medicine_ids':medicineIds,
  'page_size' : 30,
});
const onSelectChange = (value,label) => {
  pharmacyWholeSalerId.value = value;
  listSearch();
}
const listSearch = () => {
  optionFields.search_word = searchWord.value;
  optionFields.medicine_ids = medicineIds;
  optionFields.history_date_from = searchDateFrom.value;
  optionFields.history_date_to = searchDateTo.value;
  optionFields.stock_type = stockType.value;
  optionFields.stock_reason = deleteReason.value;
  optionFields.pharmacy_wholesaler_id = (pharmacyWholeSalerId.value ? pharmacyWholeSalerId.value : null);
  listRef.value.resetItem();
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}

// 発注メニューの開閉管理status
const isOpen = ref(false);
// モバイルのみ表示する為のstatus
const isMobile: boolean = Breakpoint().isBelow('sm');

// 発注メニューの開閉管理
const toggleAccordion = () => {
  isOpen.value = !isOpen.value;;
}

const historyDownload = () => {
  let params = deepCopy(optionFields);
  params['is_download'] = 1;
  //全てのデータを取得するのでページサイズを0にする
  params['page_size'] = 0;
  params['p'] = 1;
  const queryParameter = qs.stringify(params,{ arrayFormat: 'repeat'});
  window.open(props.apis.pharmacy_order_history_list + '?' + queryParameter,'_blank');
}
/////// 検索機能追加 ////////////
const onMedicineSelectChange = (values) => {
    medicineIds.splice(0);
    for (let i=0;i<values.length;i++) {
        medicineIds.push(values[i]);
    }
    listSearch();
}
///////////////////////////////
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="md:absolute top-2 left-2">
    <help-action
      help-key="order_history_help"
    ></help-action>
  </div>
  <div v-if="isMobile" class="w-auto md:w-full m-4 mb-0 md:flex items-center justify-end md:pt-9 md:p-2 border-b">
    <button  @click="toggleAccordion" class="flex items-center justify-center w-full py-2 px-4 text-gray-800 border-t border-x text-left">
      <img class="w-7 h-7" src="../../../../public/images/icon/refine_search.png" alt="絞り込み検索">
      <div class="mx-3">絞り込み検索</div>
      <div class="pull-down-icon" :class="{ 'rotate-180': isOpen }"></div>
    </button>
  </div>
  <div v-if="!isMobile || isOpen" class="border border-t-0 md:border-none w-auto md:w-full md:flex mx-4 md:m-0 md:pt-9 items-center justify-end p-2 md:bg-gray-100 md:rounded">
      <div class="md:m-1">
          <select-box
              :api-url="apis.medicine_list"
              :api-option-fields="{relation_pharmacy:1,is_relation:1,page_size:20}"
              :on-change="onMedicineSelectChange"
              :value="medicineIds"
              list-field-name="product_detail_name"
              :options="medicineOptions"
              :is-multi="true"
              place-holder="採用品を選択"
              list-height="20em"
          ></select-box>
      </div>
      <div class="md:m-1">
        <search-box
          :search-word="searchWord"
          :on-change="onSearchWordChange"
          :on-enter="onSearchWordEnter"
          place-holder="採用品名を入力"
        ></search-box>
      </div>
      <div class="m-1 flex flex-row items-center">
        <text-box
          :value="searchDateFrom"
          type="date"
          :on-change="onSearchDateFromChange"
          place-holder="日付を入力"
        ></text-box>
        <div class="tex-lg">~</div>
        <text-box
          :value="searchDateTo"
          type="date"
          :on-change="onSearchDateToChange"
          place-holder="日付を入力"
        ></text-box>
        <a @click="clearDate" class="block cursor-pointer m-1 text-lg text-red-500"><i class="fa-solid fa-calendar-xmark"></i></a>
      </div>
      <div class="m-1">
        <select-box
            :value="stockType"
            :options="config.STOCK_TYPES_OPTIONS"
            :on-change="onSelectStockTypeChange"
        ></select-box>
      </div>
      <div v-show="stockType == 3" class="m-1">
        <select-box
            :value="deleteReason"
            :options="config.STOCK_REASONS"
            :on-change="onSelectDeleteReasonChange"
        ></select-box>
      </div>
      <div class="m-1">
        <select-box
            :value="pharmacyWholeSalerId"
            :options="pharmacyWholesalers"
            list-field-name="wholesaler_common_name"
            :on-change="onSelectChange"
            place-holder="全ての卸"
        ></select-box>
      </div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="historyDownload" class="text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2">小分け履歴CSV</a>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :option-fields="optionFields"
        :api-url="apis.pharmacy_order_history_list"
        height="72vh"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <order-history-medicine-component
          :apis="apis"
          :item="slotProps.item"
          :fields="fields"
        ></order-history-medicine-component>
      </template>
      </custom-list>
  </div>
</div>
</template>

